import { Text } from "../../../../../components/general/Text";

type Props = {
  studentCount: number;
  studentCountByGrade: { grade: string; count: number }[];
};

export const StudentCountConfirmation = ({
  studentCount,
  studentCountByGrade,
}: Props) => {
  return (
    <div>
      <div className="my-6 mx-8">
        <Text size="lg" align="center">
          {studentCount}名の生徒を停止してよろしいですか？
        </Text>
      </div>
      <div className="rounded px-6 py-4 mx-8 mb-6 bg-gray-100">
        {studentCountByGrade.map((item) => (
          <Text key={item.grade} size="md" className="leading-8">
            ・{item.grade} {item.count}名
          </Text>
        ))}
      </div>
    </div>
  );
};
